module.exports = __webpack_public_path__ + "img/mascot-login.469c1e49.svg";